require('./angulartics-google-tag-manager');
module.exports = 'angulartics.google.tagmanager';



//////////////////
// WEBPACK FOOTER
// ./node_modules/angulartics-google-tag-manager/lib/index.js
// module id = 366
// module chunks = 6